export default {"src":"/_next/static/media/arrow.ef6fa297.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};